import { transparentize } from 'polished';
import styled from 'styled-components';

import { Modal } from '../Modal';

export const DescriptionWrapper = styled.div`
  margin: 0;
  padding: 0;
  font-size: 12px;
  line-height: 22px;
  color: ${({ theme }) => transparentize(0.5, theme.colors.black)};
`;

export const StyledModal = styled(Modal)`
  .modal-dialog {
    margin: 0 auto;
    height: 100vh;
    width: 100vw;
  }

  .modal-content {
    height: 95vh;
  }

  .modal-body {
    padding: 24px 24px 0 24px;
    display: flex;
    flex-direction: column;
  }

  .modal-footer {
    margin-top: 0.5em;
    padding: 0.5em 24px 0.5em 24px;
    border-top: 1px solid #e8e8e8;
    justify-content: space-between;

    & > button {
      margin: 0;
    }
  }
`;
